
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/wixData/components/emptyState.scss.css.virtualfile';
        module.exports = {"actionsContainer":"_actionsContainer_1bgt0_7","settingsIcon":"_settingsIcon_1bgt0_14"};